module.exports = __webpack_public_path__ + "01ea978f/img/grid-web-icon.d0395d64.svg";